export enum UserNetworkState {
	ACTIVE = 'ACTIVE', // LINKEDIN
	EXPIRED = 'EXPIRED', // OUTLOOK
	NOT_ACTIVE = 'NOT_ACTIVE', // GOOGLE
}
